import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, apiError } from "@/lib/shop";

const blank = { name: "", email: "", password: "" };

export const StaffManager = () => {
  const [staff, setStaff] = useState([]);
  const [f, setF] = useState(blank);
  const load = () => http.get("/staff").then((r) => setStaff(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await http.post("/staff", f); toast.success("Staff login created"); setF(blank); load(); } catch (err) { toast.error(apiError(err)); }
  };
  const remove = async (s) => {
    if (!window.confirm(`Remove ${s.name}'s login?`)) return;
    try { await http.delete(`/staff/${s.id}`); load(); } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div className="mt-6 grid md:grid-cols-2 gap-6" data-testid="staff-manager">
      <form onSubmit={add} className="bg-white rounded-xl border border-slate-200 p-5 grid gap-3">
        <p className="font-bold">Add a staff login</p>
        <p className="text-xs text-slate-500">Staff can use the parts inventory and repair requests. They can't see purchase costs or profit, or edit website products.</p>
        <div className="grid gap-1"><Label className="text-xs">Name</Label><Input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="staff-name-input" /></div>
        <div className="grid gap-1"><Label className="text-xs">Email</Label><Input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="staff-email-input" /></div>
        <div className="grid gap-1"><Label className="text-xs">Password (min 8 characters)</Label><Input type="password" required minLength={8} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="staff-password-input" /></div>
        <button className="rounded-full bg-brand py-3 font-bold text-white hover:bg-brand-700" data-testid="staff-add-btn">Create login</button>
      </form>
      <div className="grid gap-2 content-start">
        {!staff.length && <p className="text-sm text-slate-500">No staff logins yet.</p>}
        {staff.map((s) => (
          <div key={s.id} className="bg-white rounded-xl border border-slate-200 p-4 flex items-center justify-between" data-testid={`staff-row-${s.id}`}>
            <div><p className="font-bold">{s.name}</p><p className="text-sm text-slate-500">{s.email}</p></div>
            <button onClick={() => remove(s)} className="p-2 rounded-full text-red-600 hover:bg-red-50" aria-label="Remove" data-testid={`staff-delete-${s.id}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
